import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section id="articles" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-12">
          <div>
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight">
              Latest <span className="text-accent-600">Spreadsheet Finds</span><br />& Guides
            </h2>
          </div>
          <p className="text-foreground-500 text-sm max-w-md lg:text-right">
            In-depth guides, curated finds, and comparison articles to help you make the most of the <strong>Vigorbuy Spreadsheet</strong>.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              onClick={scrollToTop}
              className="group relative rounded-xl overflow-hidden h-[340px] cursor-pointer"
            >
              <div className="absolute inset-0">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>

              <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium whitespace-nowrap">
                {article.tag}
              </span>

              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-white font-semibold text-base md:text-lg leading-snug mb-2 group-hover:underline">
                  {article.title}
                </h3>
                <p className="text-white/70 text-xs leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-white/50 text-xs">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-white/40"></span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/articles/best-vigorbuy-spreadsheet-finds-2026"
            onClick={scrollToTop}
            className="px-7 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            Read SEO Guides
            <i className="ri-arrow-right-line"></i>
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:border-foreground-950 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            View All Finds
            <i className="ri-external-link-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}